import {
  NetworkEthIcon,
  NetworkSolIcon,
  NetworkBaseIcon,
  NetworkBscIcon,
  NetworkTonIcon,
} from '@root/shared/ui-kit'

import type { Network } from '@root/entities/network'
import type { IconProps } from '@root/shared/ui-kit'

export const NETWORK_ICON_MAP: Record<Network.Network, React.FC<IconProps>> = {
  solana: NetworkSolIcon,
  ethereum: NetworkEthIcon,
  bsc: NetworkBscIcon,
  base: NetworkBaseIcon,
  ton: NetworkTonIcon,
}

type Props = {
  network: Network.Network
} & IconProps

export const NetworkIcon = ({ network, ...props }: Props) => {
  const Icon = NETWORK_ICON_MAP[network]

  return <Icon {...props} />
}
